/**
 * NOTE: Formatting was intentionally omitted since we format numbers slightly different across products. If we can
 * standardize in most cases, having a standard formatter function to transform these constants would be trivial.
 */
enum ContactNumbers {
  INTERIOR_ACCESS_NUMBER = 8008410607,
  UNDER_CONTRACT_WINNER_NUMBER = 8006325045,
  PENDING_WINNER_NUMBER = 8007936107,
  BIDDER_SUPPORT_NUMBER = 8002802832,
  OFFER_SUPPORT_NUMBER = 8007936107,
  ONLINE_BUYER_EXPERIENCE = 8007936107, // creating this to aid in consolidating the pending winner and offer support numbers (which are the same) with the goal of removing references to those and all pointing to this single reference
  FCL_ONLINE_CONTACT_NUMBER = 8008519558, // This phone is displayed in PDP as a contact number for Online Foreclosure listings
  SMART_SALE_CONCIERGE = 8553223050,
  IL_ONLINE_SUPPORT_NUMBER = 8723211274, // IL office, this phone is displayed to get details about difference between online sales and a live sale for IL FCL Online
}

export default ContactNumbers

